export default {
	title: 'schedule',
	components: [{ title: 'schedule', component: 'schedule_gen_2' }],
};
